import "../JournalEntry/JournalEntry.css";
import "./ContraEntry.css";
import React, { useState, useRef, useEffect, useContext } from "react";
import "../../Master/SchemeRegistration/SchemeRegistration.css";
import "../SchemeReceipt/SchemeCashReceipt.css";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";

import close from "../../../assets/images/findclose.png";
import binImg from "../../../assets/images/Bin.png";
import ComboBox from "../../ComboBoxes/ComboBox";
import axios from "axios";
import Swal from "sweetalert2";
import Print from "../../PrintModels/Print";
import io from "socket.io-client";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../../components/NavBars/ActionToolbar";
import GridDesign from "../../GridDesign/GridDesign";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";
import { createGridKeyDownHandler } from "../../../utils/gridKeyDownHelper";

import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

function ContraEntry({ onClose, Open, zIndex, formName, voucherType }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL; 
  const { agentCode } = useContext(AuthContext);
  const { dbCode } = useDbContext();
  const permissions = useSelector(selectMenuPermissions);
  const activeFyid = useSelector(selectActiveFyid);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;
  const activeLocation = useSelector(selectActiveLocation);

  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  const [showPrintModel, setShowPrintModel] = useState(false);

  const [printData, setPrintData] = useState(null);

  const handleClosePrint = () => {
    setShowPrintModel(false);
  };
  const [startDate, setStartDate] = useState(new Date());
  /////////////table///////////
  const tableContainerRef = useRef(null);
  const cashaccref = useRef(null);

  const defaultContraGridColumns = [
    {
      sNo: 1,
      columnName: "debitAccount",
      width: 200,
      orderNo: 0,
      header: "Select Debit Account",
      show: true,
    },
    {
      sNo: 2,
      columnName: "creditAccount",
      width: 200,
      orderNo: 1,
      header: "Select Credit Account",
      show: true,
    },
    {
      sNo: 3,
      columnName: "amount",
      width: 200,
      orderNo: 2,
      header: "Amount",
      show: true,
    },
    {
      sNo: 4,
      columnName: "narration",
      width: 138,
      orderNo: 3,
      header: "Narration",
      show: true,
    },
  ];

  const [gridColumns, setGridColumns] = useState(defaultContraGridColumns);
  const vType = voucherType || formName || "CONTRA";

  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !vType) return;
      let cached = localStorage.getItem(`grid_design_${vType}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          setGridColumns(parsed);
          return;
        } catch (e) {
          console.error("Error parsing cached grid settings:", e);
        }
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
        );
        const dbCols = response.data.recordset || response.data || [];
        if (dbCols.length > 0) {
          const merged = defaultContraGridColumns.map((initCol) => {
            const dbMatch = dbCols.find(
              (c) =>
                String(c.ColName).toLowerCase() ===
                String(initCol.columnName).toLowerCase(),
            );
            if (dbMatch) {
              return {
                ...initCol,
                width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
                orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
                header: dbMatch.Header || initCol.header,
                show: dbMatch.Vis === 1,
              };
            }
            return initCol;
          });
          merged.sort((a, b) => a.orderNo - b.orderNo);
          localStorage.setItem(`grid_design_${vType}`, JSON.stringify(merged));
          setGridColumns(merged);
        }
      } catch (error) {
        console.error("Error loading grid settings:", error);
      }
    };
    loadGridSettings();
  }, [dbCode, apiBaseUrl, vType]);

  const entryNoInputRef = useRef(null);
  const branchinputRef = useRef(null);
  const salesmaninputRef = useRef(null);

  const [showFormDesignModal, setShowFormDesignModal] = useState(false);
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
    rowBreakColumn,
    rowBreakTarget,
    breakoutColumn,
    setRowBreakColumn,
    setRowBreakTarget,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.color) filtered.color = fullStyle.color;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.color) filtered.color = fullStyle.color;
    return filtered;
  };

  useEffect(() => {
    triggerInitialFocus();
  }, [triggerInitialFocus]);

  const rateInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const saveButtonRef = useRef(null);
  const editButtonRef = useRef(null);

  const addRow = () => {
    setTableData((prev) => [...prev, createEmptyRow()]);
  };

  const removeRow = (index) => {
    setTableData((prev) => {
      const next = prev.filter((_, i) => i !== index);
      const emptySlots = Math.max(0, 14 - next.length);
      return [...next, ...createEmptyRows(emptySlots)];
    });
  };

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [showGridDesignModal, setShowGridDesignModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const dropdownRef = useRef(null);

  // const handleScroll = () => {
  //   const tableContainer = tableContainerRef.current;
  //   if (
  //     tableContainer.scrollTop + tableContainer.clientHeight >=
  //     tableContainer.scrollHeight - 1
  //   ) {
  //     // User has scrolled to the bottom, add new rows
  //     addRow();
  //   }
  // };

  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();

  //////////current date///////////

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to minDate if today is earlier than the FY start
    if (minDate && formattedToday < minDate) return minDate;
    // Clamp to maxDate if today is later than the FY end
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  ////////////////////////// form data states //////////

  const createEmptyRow = () => ({
    SINo: "",
    debitAccount: "",
    creditAccount: "",
    amount: "",
    narration: "",
  });

  const createEmptyRows = (count = 14) =>
    Array.from({ length: Math.max(0, count) }, createEmptyRow);

  const [tableData, setTableData] = useState(() => createEmptyRows(14));
  //////////console.log("tabledata",tableData);
  const openPrintModal = () => {
    fetchData();
    const slnoLimit = handleCheckSlno();
    if (selectedSlNo > slnoLimit || selectedSlNo <= 0) {
      alert("Enter SlNo Correctly");
      return;
    }

    setPrintData({
      tableData: tableData,
      cvInfoData: cvInfoData,
      index: selectedSlNo,
    });
    setShowPrintModel(true);
  };
  // //////////////////console.log("table data ===== ", tableData);

  const [locationOptions, setLocationOptions] = useState([]);

  const storedLocId = sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
  const storedLocName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");

  const getDefaultBranch = () => {
    if (activeLocation?.id) return [Number(activeLocation.id), activeLocation.name];
    if (storedLocId) return [Number(storedLocId), storedLocName || "SHOP"];
    return [0, "SHOP"];
  };

  const [cvInfoData, setcvInfoData] = useState({
    EntryNo: "",
    Location: getDefaultBranch(),
    Salesman: "",
    date: initialDateVal,
    totalamt: "",
  });

  // //////////////////console.log("info data = ", cvInfoData);

  ///////////////////////////////////////////////
  // const[accountTransaction,setAccountTransaction]=useState({
  // atDate:"",
  // atLedcode:"",
  // atType:"",
  // atEntryNo:"",
  // atAmount:"",
  // atNarration:"",

  //})

  ///////////////////////////////////////////////

  const handleCellChange = (event, rowIndex, field) => {
    const newData = [...tableData]; // Create a copy of the tableData array
    newData[rowIndex] = { ...newData[rowIndex], [field]: event }; // Update the value of the specified field in the row
    setTableData(newData); // Update the tableData state with the modified data
  };

  const handleCellChangeinput = (event, rowIndex, field) => {
    const newData = [...tableData]; // Create a copy of the tableData array

    if (field === "printgm") {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event.target.checked ? 1 : 0, // If checkbox is checked, set value to 1, otherwise 0
      };
    } else {
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event.target.value,
      }; // Update the value of the specified field in the row
    }
    newData[rowIndex] = { ...newData[rowIndex], SINo: rowIndex + 1 }; // Update the SINo for the row
    setTableData(newData); // Update the tableData state with the modified data
  };

  useEffect(() => {
    entryNoInputRef.current.focus();
  }, []);

  const handleKeyDown = (event, nextInputRef) => {
    if (event.key === "Enter" || event.key === "Return") {
      nextInputRef.current.focus();
    }
  };
  const [RowIndex, setRowIndex] = useState(0);
  // //////////////////console.log(RowIndex);

  const handleKeyDownTable = (event, rowIndex, columnIndex) => {
    if (event.key === "Enter" || event.key === "Return") {
      event.preventDefault();

      const tableContainer = tableContainerRef.current;
      const rows = tableContainer.querySelectorAll(
        ".cventryDataTableBodyStyletr",
      );

      if (rows[rowIndex]) {
        // Each .cventryDataTableBodyStyletr is a flex div; first child is the data row div
        const dataRowDiv = rows[rowIndex]?.children[0];
        if (dataRowDiv) {
          const totalCols = dataRowDiv.children.length;
          const nextColumnIndex =
            columnIndex < totalCols - 1 ? columnIndex + 1 : 0;

          const nextInput = dataRowDiv.children[nextColumnIndex]?.querySelector("input");

          if (nextInput) {
            const currentInputAccno = columnIndex === 1;

            if (currentInputAccno && !event.target.value.trim()) {
              if (saveDisabled) {
                editButtonRef.current.focus();
              } else {
                saveButtonRef.current.focus();
              }
            } else {
              nextInput.focus();
            }
          }
        }
      }
    }

    setRowIndex(rowIndex);
  };

  /////////////////////////////////////////////

  useEffect(() => {
    const fetchSchEntryno = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/cv_entryno/${dbCode}/${fyid}`,
        );
        //  //////////////////console.log("response =", response);
        const schemeRecentryNo = response.data;

        setcvInfoData((prevData) => ({
          ...prevData,
          EntryNo: schemeRecentryNo,
        }));
        // setSchEntryNo(schemeentryNo[0] );
      } catch (error) {
        console.error("Error fetching entry no:", error.message);
      }
    };

    fetchSchEntryno();
  }, [apiBaseUrl, fyid, dbCode]);

  const fetchSchEntryno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/cv_entryno/${dbCode}/${fyid}`,
      );
      // //////////////////console.log("response =", response);
      const schemeRecentryNo = response.data;

      setcvInfoData((prevData) => ({
        ...prevData,
        EntryNo: schemeRecentryNo,
      }));
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  };

  const resolveEntryNo = (val, fallback = "") => {
    if (Array.isArray(val)) return val[0];
    if (val !== undefined && val !== null && val !== "") return val;
    return fallback;
  };

  //////////agent name///////////////

  const [agentName, setagentName] = useState([]);
  // const [agentobj, setAgentObj] = useState([]);

  useEffect(() => {
    const fetchAgname = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/jvschsalesmanNames/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const AgName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = AgName.map((item) => [item.Auto, item.Name]);
        setagentName(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };

    fetchAgname();
  }, [apiBaseUrl, dbCode]);

  useEffect(() => {
    const fetchLocations = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`
        );
        const data = response.data || [];
        const filtered = data
          .filter((item) => String(item.Type || item.type || "").toLowerCase() === "location")
          .map((item) => [Number(item.Auto ?? item.auto ?? 0), item.Name || item.name]);
        setLocationOptions(filtered);

        if (filtered.length > 0) {
          const targetId = activeLocation?.id || storedLocId;
          const match = targetId ? filtered.find((l) => Number(l[0]) === Number(targetId)) : null;
          const chosen = match || filtered[0];
          setcvInfoData((prev) => {
            if (!prev.Location || !prev.Location[0] || prev.Location[0] === 0) {
              return { ...prev, Location: chosen };
            }
            return prev;
          });
        }
      } catch (error) {
        console.error("Error fetching location options:", error);
      }
    };
    fetchLocations();
  }, [apiBaseUrl, dbCode, activeLocation]);

  // const fetchAgname = async (searchTerm = '') => {
  //   try {
  //     const response = await axios.get(`${apiBaseUrl}/main/jvschsalesmanNames?search=${encodeURIComponent(searchTerm)}`);
  //     const AgName = response.data;
  //     const transformedData = AgName.map((item) => [item.Auto, item.Name]);
  //     setagentName(transformedData);
  //   } catch (error) {
  //     console.error("Error fetching agent Values:", error.message);
  //   }
  // };
  // const handleAgentSearch = (searchTerm) => {
  //   fetchAgname(searchTerm);
  // };

  ////////////////////ledger/////////////////////

  const backtrackfocus = () => {
    const rowIndex = sessionStorage.getItem("contraEntryRowIndex");
    const columnIndex = sessionStorage.getItem("contraEntryColumnIndex");

    const tableContainer = tableContainerRef.current;
    const rows = tableContainer.querySelectorAll(
      ".cventryDataTableBodyStyletr",
    );

    if (rows[rowIndex]) {
      // Each .cventryDataTableBodyStyletr is a flex div with two children:
      //   [0] = data row div (contains SI No div + column divs)
      //   [1] = spacer div
      const dataRowDiv = rows[rowIndex]?.children[0];
      if (dataRowDiv) {
        const nextColumnIndex =
          Number(columnIndex) - 1 < dataRowDiv.children.length - 1
            ? Number(columnIndex)
            : 0;
        const nextInput = dataRowDiv.children[nextColumnIndex]?.querySelector("input");
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
    sessionStorage.removeItem("contraEntryRowIndex");
    sessionStorage.removeItem("contraEntryColumnIndex");
  };

  const [LedgerName, setLedgerName] = useState([]);

  useEffect(() => {
    const fetchLgname = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/common/selectCashAndBank/${dbCode}`,
        );

        const LgName = response.data;

        const transformedData = LgName.map((item) => [
          item.ledcode,
          item.LedName,
        ]);
        setLedgerName(transformedData);
      } catch (error) {
        console.error("Error fetching ledger Values:", error.message);
      }
      backtrackfocus();
    };

    fetchLgname();

    // Connect to the WebSocket server
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("dataUpdated", () => {
      //   //////////////////console.log('Data updated, fetching new data...');
      fetchLgname(); // Re-fetch the data when an update is detected
    });

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
      //   //////////////////console.log("socketdisconneccted");
    };
  }, [apiBaseUrl, dbCode]);

  const handleCheckLedger = (e, rowIndex, columnIndex) => {
    // //////////////////console.log('regcustom',AcNames);

    const targetValue = e.target.value;

    const isValuePresent = LedgerName.some((item) => item[1] === targetValue);

    if (!isValuePresent && e.target.value !== "") {
      if (!window.confirm("Ledger Does not Exists,Create New..?")) {
        return;
      }
      Open(e, rowIndex, columnIndex);
    }
  };

  ////////////////total calculations/////////////////////////////

  useEffect(() => {
    let totalAmount = 0;
    let totalGm = 0;
    tableData.forEach((rowData) => {
      totalAmount += parseFloat(rowData.amount || 0);
      totalGm += parseFloat(rowData.gm || 0);
    });
    setcvInfoData((prevState) => ({
      ...prevState,
      totalamt: totalAmount.toFixed(3), // Update total amount
      totalgm: totalGm.toFixed(3), // Update total gm
    }));
  }, [tableData]);

  ////////////////////

  const [comboValue, setComboValue] = useState("");
  const handleClearCombo = () => {
    setComboValue("");
  };
  ///////////////////////////////////clear/////////////////////////////

  const handleClear = () => {
    fetchSchEntryno();

    setcvInfoData({
      Location: getDefaultBranch(),
      Salesman: "",
      date: getCurrentDate(),
    });

    setTableData(createEmptyRows(14));

    triggerInitialFocus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };

  const handleClearfind = () => {
    setcvInfoData({
      Location: getDefaultBranch(),
      Salesman: "",
      date: getCurrentDate(),
    });

    setTableData(createEmptyRows(14));

    triggerInitialFocus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };
  ////////////////////////////////////////////////////////
  console.log("tableData111111", tableData);

  const handleSave = async () => {
    setSaveDisabled(true);

    try {
      if (cvInfoData.date && !isDateInFy(cvInfoData.date)) {
        alert("Date incompatible with financial year");
        setSaveDisabled(false);
        return;
      }
      console.log("tableData", tableData);

      const hasIncompleteData = tableData.some((row) => {
        return (
          Object.values(row).some((value) => value !== "") &&
          (!row.debitAccount ||
            !row.creditAccount ||
            !row.amount ||
            !cvInfoData.Salesman)
        );
      });

      if (hasIncompleteData) {
        console.log("11111111111111111111");

        alert("Enter Data Correctly.");
        setSaveDisabled(false);
        console.log("22222222222222222222");
        return;
      }

      const hasData = tableData.some((row) => {
        return (
          row.debitAccount &&
          row.creditAccount &&
          row.amount &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving
        console.log("33333333333333333333");

        alert("Enter Data  Correctly.");
        setSaveDisabled(false);
        console.log("44444444444444444444");
        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        debitAccount: row.debitAccount[0] || null,
        creditAccount: row.creditAccount[0] || null,
        amount: parseInt(row.amount) || null,
        narration: row.narration || null,
      }));
      // //////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.post(
        `${apiBaseUrl}/main/savecventry/${dbCode}/${fyid}`,
        {
          Location: Number(
            cvInfoData.Location?.[0] ||
            activeLocation?.id ||
            sessionStorage.getItem("loginLocationId") ||
            0
          ),
          Salesman: cvInfoData.Salesman[0],
          date: cvInfoData.date,
          EntryNo: cvInfoData.EntryNo,
          totalAmount: cvInfoData.totalamt,
          type: transformedTableData, // Pass the entire tableData array
        },
      );

      if (response.data.success) {
        handleClear();
        //  Swal.fire("Success", "Data saved successfully!", "success");

        alert("Entry Saved");

        // Optionally, you can perform additional actions after successful save
      } else {
        //Swal.fire("Error", "Failed to save data!", "error");
        // alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      //  Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
      setSaveDisabled(false);
    }
    // handleClear();
  };

  const handleEdit = async () => {
    if (!window.confirm("Do You Want To Edit This Entry..?")) {
      return;
    }
    try {
      const hasIncompleteData = tableData.some((row) => {
        return (
          Object.values(row).some((value) => value !== "") &&
          (!row.debitAccount ||
            !row.creditAccount ||
            !row.amount ||
            !cvInfoData.Salesman)
        );
      });

      if (hasIncompleteData) {
        alert("Enter Data Correctly.");
        setSaveDisabled(false);
        return;
      }

      if (!cvInfoData.Location) {
        alert("Enter Data  Correctly.");
        return;
      }

      const hasData = tableData.some((row) => {
        return (
          row.debitAccount &&
          row.creditAccount &&
          row.amount &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving

        alert("Enter Data  Correctly.");
        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        debitAccount: row.debitAccount[0] || null,
        creditAccount: row.creditAccount[0] || null,
        amount: parseInt(row.amount) || null,
        narration: row.narration || null,
      }));
      ////////////////////console.log("transformedTableData", transformedTableData);
      const cleanEntryNo = resolveEntryNo(cvInfoData.EntryNo);
      if (!cleanEntryNo) {
        alert("Invalid Entry No to edit!");
        return;
      }

      const response = await axios.post(
        `${apiBaseUrl}/main/cvupdate/${dbCode}/${fyid}`,
        {
          Location: Number(
            cvInfoData.Location?.[0] ||
            activeLocation?.id ||
            sessionStorage.getItem("loginLocationId") ||
            0
          ),
          Salesman: cvInfoData.Salesman[0],
          date: cvInfoData.date,
          EntryNo: cleanEntryNo,
          type: transformedTableData, // Pass the entire tableData array
        },
      );

      if (response.data.success) {
        handleClear();

        // Swal.fire("Success", "Data Edit successfully!", "success");

        alert("Entry Edited");
        // Optionally, you can perform additional actions after successful save
        entryNoInputRef.current.focus();
      } else {
        // Swal.fire("Error", "Failed to edit data!", "error");
        alert("Failed to edit data!");
      }
    } catch (error) {
      console.error("Error edit data:", error.message);
      // Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
    }
    // handleClear();
  };

  ////////////////////console.log("datra",tableData[0].accountNumber);

  const [showFindDialog, setShowFindDialog] = useState(false); // State for controlling the visibility of the find dialog
  const [findEntryNo, setFindEntryNo] = useState(""); // State to store the entry number entered in the find dialog
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [selectedSlNo, setSelectedSlno] = useState("");

  // //////////////////console.log(findEntryNo);
  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const openPrintDialog = () => {
    setShowPrintDialog(true);
  };

  const closePrintDialog = () => {
    setShowPrintDialog(false);
  };

  const [firstEno, setFirstEno] = useState("");
  const [lastEno, setLastEno] = useState("");
  ////////////////////console.log(firstEno,lastEno);

  const fetchfirstandlast = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/cvtopandlast/${dbCode}/${fyid}`,
      );
      if (response.status === 200) {
        setFirstEno(response.data[0].firstentryno);
        setLastEno(response.data[0].lastentryno);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // //////////////////console.log('accNo==',accNo);
  // //////////////////console.log('accccc=',accNo.find((item) => item[0] === 10));

  const handleFindbyentrynumber = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/findcv/${findEntryNo}/${dbCode}/${fyid}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setcvInfoData({
          ...cvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: resolveEntryNo(firstRowData.EntryNo, findEntryNo),
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        const emptySlots = Math.max(0, 14 - newData.length);
        setTableData([...newData, ...createEmptyRows(emptySlots)]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  // //////////////////console.log('formatted date',formatDate);

  const handleDelete = async () => {
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }
    const cleanEntryNo = resolveEntryNo(cvInfoData.EntryNo);
    if (!cleanEntryNo) {
      alert("Invalid Entry No to delete!");
      return;
    }
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deletecv/${cleanEntryNo}/${dbCode}/${fyid}?location=${cvInfoData.Location ? cvInfoData.Location[0] : 0}`,
      );
      if (response.status === 200) {
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Scheme deleted",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        alert("Entry Deleted Successfully!");
        // window.location.reload();
        handleClear();
      } else {
        console.error("Error deleting data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleFindprev = async (e) => {
    fetchfirstandlast();
    const currentEno = resolveEntryNo(cvInfoData.EntryNo);
    if (currentEno > firstEno) {
      handleClearfind();
    }
    // else{
    //   return;
    // }
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/cvprevs/${currentEno}/${dbCode}/${fyid}`,
      );

      //  //////////////////console.log("response=",response.data);
      if (response.status === 200) {
        const foundData = response.data;
        ////////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setcvInfoData({
          ...cvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: resolveEntryNo(firstRowData.EntryNo, findEntryNo),
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData
        const emptySlots = Math.max(0, 14 - newData.length);
        setTableData([...newData, ...createEmptyRows(emptySlots)]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleFindnext = async () => {
    fetchfirstandlast();
    const currentEno = resolveEntryNo(cvInfoData.EntryNo);
    if (currentEno < lastEno) {
      handleClearfind();
    }

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/cvnext/${currentEno}/${dbCode}/${fyid}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        ////////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setcvInfoData({
          ...cvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: resolveEntryNo(firstRowData.EntryNo, findEntryNo),
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData
        const emptySlots = Math.max(0, 14 - newData.length);
        setTableData([...newData, ...createEmptyRows(emptySlots)]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindfirst = async () => {
    handleClearfind();
    try {
      const response = await axios.get(`${apiBaseUrl}/main/cvfirst/${dbCode}/${fyid}`);

      if (response.status === 200) {
        const foundData = response.data;
        //////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setcvInfoData({
          ...cvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: resolveEntryNo(firstRowData.EntryNo, findEntryNo),
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData
        const emptySlots = Math.max(0, 14 - newData.length);
        setTableData([...newData, ...createEmptyRows(emptySlots)]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindlast = async () => {
    handleClearfind();
    try {
      const response = await axios.get(`${apiBaseUrl}/main/cvlast/${dbCode}/${fyid}`);

      if (response.status === 200) {
        const foundData = response.data;
        ////////////////////console.log(foundData);
        //  //////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          debitAccount: LedgerName.find((item) => item[0] === row.Name),
          creditAccount: LedgerName.find((item) => item[0] === row.opposite),
          amount: row.DebitAmount,
          narration: row.narration, // You might need to adjust this based on your requirements
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setcvInfoData({
          ...cvInfoData,
          Location: locationOptions.find((item) => item[0] === firstRowData.Location) || [firstRowData.Location, "SHOP"],
          EntryNo: resolveEntryNo(firstRowData.EntryNo, findEntryNo),
          Salesman: agentName.find((item) => item[0] === firstRowData.SalesMan),
          date: formatDate(firstRowData.DDate),
          totalamt: firstRowData.Amount,
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        // Add the new data to tableData
        const emptySlots = Math.max(0, 14 - newData.length);
        setTableData([...newData, ...createEmptyRows(emptySlots)]);

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleCheckSlno = () => {
    const filteredTableData = tableData.filter((row) => {
      // Check if any of the fields in the row is not empty
      return Object.values(row).some((value) => value !== "");
    });
    const filteredTableDataLength = filteredTableData.length;
    return filteredTableDataLength;
  };

  const [accumulatedWt, setaccumulatedWt] = useState("");
  // //////////////////console.log("accumulatedWt",accumulatedWt);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/totalweight/${
          tableData[selectedSlNo - 1 || 0].name[0]
        }/${dbCode}`,
      );
      ////////////////////console.log("res===",response.data);
      setaccumulatedWt(response.data[0].WeightDifference);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    handleClear();
    setTimeout(() => {
      setIsRefreshing(false);
    }, 600);
  };

  return (
    <div
      className="bg-white
        font-Poppins
        w-[60%]
        h-[77%]
        lg:w-[850px]
        lg:h-[480px]
        rounded-[10px]
        shadow-md
        flex
        flex-col
        items-center
        absolute
        transition-all
        duration-300"
      style={{ zIndex }}
    >
      <WindowHeader
        title="Contra Entry"
        logo={headeLogo}
        onClose={onClose}
        style={{ height: "30px" }}
        className="bg-[#0f56d3] text-white"
        titleClassName="text-xs"
        closeBtnClassName="w-6 h-6 rounded-[5px] border-none mr-2 flex items-center justify-center"
      />

        {/* ActionToolbar */}
        <ActionToolbar
          width="100%"
          height="auto"
          size="small"
          iconSize={14}
          navBgColor="#0f56d3"
          navIconColor="#ffffff"
          buttonGap="5px"
          saveBtnId="SaveBtn"
          printBtnId="PrintBtn"
          clearBtnId="ClearBtn"
          findBtnId="FindBtn"
          editBtnId="EditBtn"
          deleteBtnId="DeleteBtn"
          exitBtnId="ExitBtn"
          saveDisabled={saveDisabled}
          editDisabled={editDisabled}
          deleteDisabled={deleteDisabled}
          dataFound={!editDisabled}
          onSave={handleSave}
          onPrint={openPrintDialog}
          onClear={handleClear}
          onFind={openFindDialog}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onExit={onClose}
          onFirst={handleFindfirst}
          onPrevious={handleFindprev}
          onNext={handleFindnext}
          onLast={handleFindlast}
          permissions={permissions["cvEntry"]}
          showSave={isFieldVisible("SaveBtn")}
          showPrint={isFieldVisible("PrintBtn")}
          showClear={isFieldVisible("ClearBtn")}
          showFind={isFieldVisible("FindBtn")}
          showEdit={isFieldVisible("EditBtn")}
          showDelete={isFieldVisible("DeleteBtn")}
          showExit={isFieldVisible("ExitBtn")}
          showSettingsBar={true}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          settingsOptions={[
            {
              label: "Design Columns",
              onClick: () => setShowGridDesignModal(true),
            },
            {
              label: "Design Form",
              onClick: () => setShowFormDesignModal(true),
            },
          ]}
          onRefsUpdate={(refs) => {
            if (refs.saveButtonRef && refs.saveButtonRef.current) {
              saveButtonRef.current = refs.saveButtonRef.current;
              registerRef("SaveBtn")(refs.saveButtonRef.current);
            }
            if (refs.editButtonRef && refs.editButtonRef.current) {
              editButtonRef.current = refs.editButtonRef.current;
              registerRef("EditBtn")(refs.editButtonRef.current);
            }
          }}
        />

      <div className="cventryBody">
        <div className="cventryBodyData">
          <div className="cventryTopdata">
            <div className="cventryTopdatasections cventrysec1" style={getContainerStyle("EntryNo")}>
              {isFieldVisible("EntryNo") && (
                <div className="cventryTopdatasectionsrows">
                  <label style={getLabelStyle("EntryNo")}>Entry No</label>
                  <input
                    ref={(el) => {
                      entryNoInputRef.current = el;
                      registerRef("EntryNo")(el);
                    }}
                    readOnly
                    style={getInputStyle("EntryNo", { textAlign: "center" })}
                    value={cvInfoData.EntryNo}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "EntryNo")}
                    onChange={(e) =>
                      setcvInfoData({
                        ...cvInfoData,
                        EntryNo: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              <div className="cventryTopdatasectionsrows"></div>
            </div>
            <div className="cventryTopdatasections cventrysec2">
              <div className="cventryTopdatasectionsrows sec2row" style={getContainerStyle("Branch")}>
                {isFieldVisible("Branch") && (
                  <>
                    <label style={getLabelStyle("Branch")}>Select Location</label>
                    <ComboBox
                      id="Branch"
                      findedValue={
                        Array.isArray(cvInfoData.Location)
                          ? cvInfoData.Location[1]
                          : cvInfoData.Location
                      }
                      comboRef={(el) => {
                        branchinputRef.current = el;
                        registerRef("Branch")(el);
                      }}
                      options={locationOptions}
                      className="cashaccCombo"
                      inputClassName="cashaccComboinput"
                      inputStyle={getInputStyle("Branch")}
                      onKeyDown={(e) => {
                        handleDynamicKeyDown(e, "Branch");
                      }}
                      onInputChange={(e) =>
                        setcvInfoData({ ...cvInfoData, Location: e })
                      }
                    />
                  </>
                )}
              </div>
              <div className="cventryTopdatasectionsrows sec2row" style={getContainerStyle("Salesman")}>
                {isFieldVisible("Salesman") && (
                  <>
                    <label style={getLabelStyle("Salesman")}>Select Salesman</label>
                    <ComboBox
                      id="Salesman"
                      findedValue={
                        Array.isArray(cvInfoData.Salesman)
                          ? cvInfoData.Salesman[1]
                          : cvInfoData.Salesman
                      }
                      comboRef={(el) => {
                        salesmaninputRef.current = el;
                        registerRef("Salesman")(el);
                      }}
                      options={agentName}
                      className="cashaccCombo"
                      inputClassName="cashaccComboinput"
                      inputStyle={getInputStyle("Salesman")}
                      onKeyDown={(e) => {
                        handleDynamicKeyDown(e, "Salesman");
                      }}
                      onInputChange={(e) => {
                        setcvInfoData({ ...cvInfoData, Salesman: e });
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="cventryTopdatasections  cventrySec3" style={getContainerStyle("Date")}>
              {isFieldVisible("Date") && (
                <div
                  className="cventryTopdatasectionsrows sec3row"
                  style={{ width: "14vw" }}
                >
                  <label style={getLabelStyle("Date")}>Date</label>
                  <input
                    id="Date"
                    value={cvInfoData.date}
                    type="date"
                    min={minDate}
                    max={maxDate}
                    ref={(el) => {
                      dateInputRef.current = el;
                      registerRef("Date")(el);
                    }}
                    style={getInputStyle("Date")}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "Date")}
                    onChange={(e) => {
                      setcvInfoData({
                        ...cvInfoData,
                        date: e.target.value,
                      });
                    }}
                    onBlur={(e) => {
                      const val = e.target.value;
                      if (val && !isDateInFy(val)) {
                        alert("Date incompatible with financial year");
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/*---------------- receipt data table.----------------------- */}

          <div
            className="cventryDataTable"
            ref={tableContainerRef}
          >
            {/* ── Header ── */}
            <div className="w-max min-w-full flex sticky z-30 top-0">
              <div className="w-max min-w-full h-[1.5rem] bg-[#026CC3] flex">
                {/* SI No header */}
                <div
                  style={{ width: 50, flexShrink: 0 }}
                  className="h-full jvTableColBorder flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                >
                  SI No
                </div>
                {gridColumns.map((col) => {
                  if (!col.show) return null;
                  return (
                    <div
                      key={col.columnName}
                      style={{ width: `${col.width}px`, flexShrink: 0 }}
                      className="h-full jvTableColBorder flex items-center justify-center text-white font-inter text-xs font-medium leading-[15px] tracking-normal text-center"
                    >
                      {col.header}
                    </div>
                  );
                })}
                <div
                  style={{ width: "40px", flexShrink: 0 }}
                  className="h-full jvTableColBorder flex items-center justify-center"
                />
              </div>
            </div>

            {/* ── Body ── */}
            <div className="w-max min-w-full h-max flex flex-col">
              {tableData.map((rowData, rowIndex) => {
                const handleGridKeyDown = createGridKeyDownHandler({
                  rowIndex, breakoutColumn, rowBreakColumn, rowBreakTarget,
                  formFields, addRow, focusField, handleDynamicKeyDown,
                });

                return (
                  <div
                    key={rowIndex}
                    className="cventryDataTableBodyStyletr w-max min-w-full h-[3rem] bg-white flex flex-col"
                  >
                    {/* ── Top half: input fields ── */}
                    <div className="w-max min-w-full h-1/2 bg-white flex">
                      {/* SI No cell */}
                      <div
                        className="h-full jvTableColBorder flex items-center justify-center font-inter text-xs font-medium leading-[15px] tracking-normal text-center text-black"
                        style={{ width: 50, flexShrink: 0 }}
                      >
                        {rowIndex + 1}
                      </div>

                      {gridColumns
                        .filter((c) => c.show)
                        .map((col, visibleIndex) => {
                          const colStyle = { width: `${col.width}px`, flexShrink: 0 };
                          const columnName = col.columnName;
                          const cellClass = "h-full jvTableColBorder flex items-center font-inter text-xs";

                          const renderCell = {
                            debitAccount: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <ComboBox
                                  id={`grid_${rowIndex}_debitAccount`}
                                  findedValue={
                                    Array.isArray(tableData[rowIndex]?.debitAccount)
                                      ? (tableData[rowIndex]?.debitAccount?.[1] ?? "")
                                      : tableData[rowIndex]?.debitAccount
                                  }
                                  options={LedgerName}
                                  className="w-full h-full border-none"
                                  inputClassName="dataBox"
                                  comboRef={registerRef(`grid_${rowIndex}_debitAccount`)}
                                  onKeyDown={(e) => handleGridKeyDown(e, "debitAccount")}
                                  onInputChange={(e) => handleCellChange(e, rowIndex, "debitAccount")}
                                  onBlur={(e) => handleCheckLedger(e, rowIndex, 1)}
                                />
                              </div>
                            ),
                            creditAccount: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <ComboBox
                                  id={`grid_${rowIndex}_creditAccount`}
                                  findedValue={
                                    Array.isArray(tableData[rowIndex]?.creditAccount)
                                      ? (tableData[rowIndex]?.creditAccount?.[1] ?? "")
                                      : tableData[rowIndex]?.creditAccount
                                  }
                                  options={LedgerName}
                                  className="w-full h-full border-none"
                                  inputClassName="dataBox"
                                  comboRef={registerRef(`grid_${rowIndex}_creditAccount`)}
                                  onKeyDown={(e) => handleGridKeyDown(e, "creditAccount")}
                                  onInputChange={(e) => handleCellChange(e, rowIndex, "creditAccount")}
                                  onBlur={(e) => handleCheckLedger(e, rowIndex, 2)}
                                />
                              </div>
                            ),
                            amount: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_amount`}
                                  ref={registerRef(`grid_${rowIndex}_amount`)}
                                  value={tableData[rowIndex]?.amount || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-right text-black text-xs"
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "amount")}
                                  onKeyDown={(e) => handleGridKeyDown(e, "amount")}
                                  type="number"
                                />
                              </div>
                            ),
                            narration: () => (
                              <div key={columnName} style={colStyle} className={cellClass}>
                                <input
                                  id={`grid_${rowIndex}_narration`}
                                  ref={registerRef(`grid_${rowIndex}_narration`)}
                                  value={tableData[rowIndex]?.narration || ""}
                                  className="font-Inter h-[95%] w-full border-none p-0 m-0 text-black text-xs"
                                  onKeyDown={(e) => handleGridKeyDown(e, "narration")}
                                  onChange={(e) => handleCellChangeinput(e, rowIndex, "narration")}
                                />
                              </div>
                            ),
                          };

                          const renderer = renderCell[columnName];
                          if (renderer) return renderer();
                          return <div key={columnName} style={colStyle} className="h-full jvTableColBorder" />;
                        })}
                      <div
                        style={{ width: "40px", flexShrink: 0 }}
                        className="h-full jvTableColBorder flex items-center justify-center cursor-pointer hover:bg-red-50"
                        onClick={() => removeRow(rowIndex)}
                        title="Remove Row"
                      >
                        <img src={binImg} alt="Remove" className="w-4 h-4" />
                      </div>
                    </div>

                    {/* ── Bottom half: secondary row (EBEBEB) ── */}
                    <div className="w-max min-w-full h-1/2 bg-[#EBEBEB] flex">
                      <div style={{ width: 50, flexShrink: 0 }} className="h-full" />
                      {gridColumns
                        .filter((c) => c.show)
                        .map((col) => (
                          <div
                            key={col.columnName}
                            style={{ width: `${col.width}px`, flexShrink: 0 }}
                            className="h-full"
                          />
                        ))}
                      <div style={{ width: "40px", flexShrink: 0 }} className="h-full" />
                    </div>
                  </div>
                );
              })}
            </div>

            {/* ── Footer ── */}
            <div className="w-max min-w-full h-[26px] bg-[#026cc3] flex text-[10px] font-semibold leading-normal text-white sticky bottom-0 z-30">
              {/* SI No footer cell */}
              <div
                style={{ width: 50, flexShrink: 0 }}
                className="h-full jvTableColBorder flex items-center justify-center"
              />
              {gridColumns.filter((c) => c.show).map((col) => {
                if (col.columnName === "amount") {
                  return (
                    <div
                      key={col.columnName}
                      style={{ width: `${col.width}px`, flexShrink: 0 }}
                      className="h-full jvTableColBorder flex items-center justify-end px-1"
                    >
                      <input
                        value={cvInfoData.totalamt}
                        style={{
                          textAlign: "right",
                          width: "100%",
                          height: "22px",
                          border: "none",
                          background: "white",
                          paddingRight: "4px",
                          boxSizing: "border-box",
                          color: "#000",
                          fontSize: "10px",
                        }}
                        readOnly
                      />
                    </div>
                  );
                }
                return (
                  <div
                    key={col.columnName}
                    style={{ width: `${col.width}px`, flexShrink: 0 }}
                    className="h-full jvTableColBorder"
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {showFindDialog && (
        <div className="find-dialog">
          <input
            type="text"
            value={findEntryNo}
            onChange={(e) => setFindEntryNo(e.target.value)}
            placeholder="Enter Entry No"
          />
          <button onClick={handleFindbyentrynumber}>Find</button>
          {/* <button
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
          >
            Cancel
          </button> */}
          <div
            className="findCloseDiv"
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}

      {showPrintDialog && (
        <div className="find-dialog">
          <input
            type="text"
            // value={findEntryNo}
            onChange={(e) => setSelectedSlno(e.target.value)}
            placeholder="Enter Sl No"
          />
          <button onClick={openPrintModal}>Print</button>
          <div
            className="findCloseDiv"
            onClick={() => {
              closePrintDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}
      {showPrintModel && (
        <Print
          printData={printData}
          onClose={handleClosePrint}
          totalwt={accumulatedWt}
        />
      )}
      {showGridDesignModal && (
        <GridDesign
          onClose={() => setShowGridDesignModal(false)}
          onSave={(columns) => {
            setGridColumns(columns);
            localStorage.setItem(`grid_design_${vType}`, JSON.stringify(columns));
            setShowGridDesignModal(false);
          }}
          formName={vType}
          initialColumns={defaultContraGridColumns}
        />
      )}
      {showFormDesignModal && (
        <FormDesign
          onClose={() => setShowFormDesignModal(false)}
          formName={vType}
          initialFields={defaultContraFormFields}
          zIndex={zIndex}
          highlightFieldId={activeFieldId}
          onSave={(updatedFields) => {
            setFormFields(updatedFields);
          }}
        />
      )}
    </div>
    // </div>
  );
}

function ContraEntryWrapper(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const formName = props.voucherType || props.formName || "CONTRA";
  return (
    <FormDesignProvider
      formName={formName}
      defaultFields={defaultContraFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <ContraEntry {...props} />
    </FormDesignProvider>
  );
}

const defaultContraFormFields = [
  // ── Header Fields ──
  {
    fieldId: "EntryNo",
    fieldName: "Entry No",
    tabIndex: 0,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Branch",
    fieldName: "Select Location",
    tabIndex: 1,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Salesman",
    fieldName: "Select Salesman",
    tabIndex: 2,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Date",
    fieldName: "Date",
    tabIndex: 3,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid ──
  {
    fieldId: "Grid",
    fieldName: "Contra Grid",
    tabIndex: 4,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Grid",
  },
  // ── Grid Inputs ──
  {
    fieldId: "grid_debitAccount",
    fieldName: "Grid - Select Debit Account",
    tabIndex: 5,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_creditAccount",
    fieldName: "Grid - Select Credit Account",
    tabIndex: 6,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
  },
  {
    fieldId: "grid_amount",
    fieldName: "Grid - Amount",
    tabIndex: 7,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_narration",
    fieldName: "Grid - Narration",
    tabIndex: 8,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 9,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintBtn",
    fieldName: "Print",
    tabIndex: 10,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 11,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 12,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 13,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 14,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 15,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Breakout / Row-Break Config Pseudo-Fields ──
  {
    fieldId: "__GridBreakoutColumn",
    fieldName: "Grid Breakout Column",
    tabIndex: 9999,
    defaultValue: "debitAccount",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridBreakoutTarget",
    fieldName: "Grid Breakout Target",
    tabIndex: 9999,
    defaultValue: "SaveBtn",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakColumn",
    fieldName: "Grid Row-Break Column",
    tabIndex: 9999,
    defaultValue: "narration",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakTarget",
    fieldName: "Grid Row-Break Target",
    tabIndex: 9999,
    defaultValue: "debitAccount",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
];

export default ContraEntryWrapper;
